export const DATE_FORMATS = [
    {
        data: 'AMERICAN',
        view: 'mm/dd/yyyy'
    },
    {
        data: 'EUROPEAN',
        view: 'dd/mm/yyyy'
    }
];

export const MOMENT_BACKEND_DATE_FORMAT = 'YYYY-MM-DD';


// WEBPACK FOOTER //
// ./src/constants/dateFormats.js